// ポータルサイト連動
const PortalSiteLink = {
  namespaced: true,

  state: {
    suumo: false,
    homes: false,
    athome: false,
  },
  getters: {
    getPortalSiteLink: state => {
      return state
    },
    getSuumo: state => {
      return state.suumo
    },
    getHomes: state => {
      return state.homes
    },
    getAthome: state => {
      return state.athome
    },
  },
  mutations: {
    setPortalSiteLink(state, params) {
      _.forEach(params, function (value, key) {
        state[key] = value
      })
    },
    setSuumo(state, val) {
      state.suumo = val
    },
    setHomes(state, val) {
      state.homes = val
    },
    setAthome(state, val) {
      state.athome = val
    },
  },
  actions: {},
}

export default PortalSiteLink
